import ActionTypes from '../actionTypes';
import { DesignStatus } from '../types';

const setDesignStatus = (designStatus: DesignStatus) => ({
  type: ActionTypes.SET_DESIGN_STATUS,
  designStatus,
});

export default setDesignStatus;
